var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mb-1"},[(_vm.captured)?_c('badge',{attrs:{"type":"success"}},[_vm._v("\n        Captured\n    ")]):_c('badge',{attrs:{"type":"default"}},[_vm._v("\n        Not Captured\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }